export function toDictionary<T extends { guid: string }>(array: T[]): Record<string, T> {
  return Object.fromEntries(array.map((item) => [item.guid, item]));
}
